import classnames from 'classnames';
import React from 'react';
import Button from './Button';
const RoundedDangerButton = ({ additionClasses = '', ...props }) => (<Button additionClasses={classnames(additionClasses, 'btn-rounded')} buttonStyle="danger" {...props}/>);
export default RoundedDangerButton;
